import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import store from 'Redux/store';
import ProductAddToCartBtn from 'Components/ProductAddToCartBtn/ProductAddToCartBtn';
import useViewport from 'Hooks/useViewport';
import WishlistButton from 'Components/WishlistButton/WishlistButton';

import 'Features/Product/components/ProductHeader/ProductHeaderButtons.scss';

function ProductHeaderButtons({
  product,
  showBigWishListButton,
}) {
  const freeToPlay = get(product, 'free_to_play', false);
  const freeToPlayCta = get(product, 'free_to_play_cta', '');
  const freeToPlayUrl = get(product, 'free_to_play_url', '');
  const presale = get(product, 'presale', false);
  const productId = get(product, '_id', '');
  const slug = get(product, 'slug', '');
  const soldOut = get(product, 'sold_out', false);
  const payWhatYouWant = get(product, 'pay_what_you_want', false);

  const { isBelowLg } = useViewport();

  const onFreeToPlayClick = () => store.dispatch({
    type: 'frontend/product/FREE_TO_PLAY',
    payload: {
      productName: product.name,
      productId: product._id,
      targetURL: freeToPlayUrl,
    },
  });

  if (freeToPlay && freeToPlayUrl) {
    return (
      <>
        <a href={`${freeToPlayUrl}`} target="_blank" rel="noopener noreferrer" className="ProductAddToCartButton btn-primary ProductAddToCartButton--oldStyle" onClick={() => onFreeToPlayClick()}>
          <div className="ProductAddToCartButton__icon">
            <FontAwesomeIcon icon={faUpRightFromSquare} />
          </div>
          <div className="ProductAddToCartButton__text">
            {freeToPlayCta ?
              <>{freeToPlayCta}</> :
              <FormattedMessage id="product-add-to-cart-button.play-now" defaultMessage="Play Now" />
            }
          </div>
        </a>

        <p className="free-to-play-support-text">
          <FormattedMessage id="product-add-to-cart-button.freetoplay.description" defaultMessage="You will be redirected to our partner website" />
        </p>
      </>
    );
  }

  if (showBigWishListButton) {
    return (
      <div className="ProductWishlistButtonLarge">
        <WishlistButton
          bigButton
          slug={slug}
          product={product}
          productId={productId}
        />
      </div>
    );
  }

  if (soldOut || presale || freeToPlay || payWhatYouWant) return false;

  return (
    <div className="ProductHeaderButtons">
      <ProductAddToCartBtn oldStyle product={product} />

      {isBelowLg &&
        <div className="ProductWishlistButton">
          <WishlistButton
            slug={slug}
            product={product}
            productId={productId}
            page="product"
          />
        </div>
      }
    </div>
  );
}

ProductHeaderButtons.propTypes = {
  product: PropTypes.shape({}),
  showBigWishListButton: PropTypes.bool,
};

ProductHeaderButtons.defaultProps = {
  product: {},
  showBigWishListButton: false,
};

export default ProductHeaderButtons;
